//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import VConsole from 'vconsole'
import AppContainer from './components/AppContainer'
import { noticeMySubscribe } from './api/my'

export default {
  name: 'app',
  components: { AppContainer },
  data() {
    return {
      console: null,
      popupViewList: [],
      popupObj: null,
      intervalSecond: 0,
      showSubscribeNotice: false
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'isDebug',
      'user',
      'showPopup',
      'popupSetting',
      'scroll'
    ]),
    currentRouter() {
      return this.$route.name
    },
    key() {
      return this.$route.fullPath
    }
  },
  watch: {
    isDebug() {
      if (this.isDebug) {
        this.console = new VConsole()
      } else {
        this.console.destroy()
      }
    },
    $route(to, from) {
      if (to.query && to.query.mode && to.query.mode === 'debugab') {
        this.$store.dispatch('SetDebug', true)
      } else if (to.query && to.query.mode && to.query.mode === 'normal') {
        this.$store.dispatch('SetDebug', false)
      }
      if (from.meta.keepAlive) {
        this.$store.dispatch('SetRouteScroll', { routeName: from.name, scrollTop: this.$refs.viewBox.getScrollTop() })
      }
      const _this = this
      if (to.meta.keepAlive && to.meta.isBack) {
        setTimeout(function() {
          if (_this.scroll[to.name]) {
            _this.$refs.viewBox.scrollTo(_this.scroll[to.name])
          }
        })
      }
    },
    popupSetting: {
      handler(val) {
        this.popupObj = this.popupSetting
      },
      deep: true,
      immediate: true
    },
    showPopup() {
      if (this.showPopup) {
        this.intervalSecond = this.popupObj.interval
        const _this = this
        if (this.intervalSecond > 0) {
          const interval = window.setInterval(function() {
            _this.intervalSecond -= 1
            if (_this.intervalSecond === 0) {
              clearInterval(interval)
            }
          }, 1000)
        }
      }
    },
    user: {
      handler() {
        this.checkUserSubscribeNotice()
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // this.console = new VConsole()
    this.popupObj = this.popupSetting
    this.$store.commit('SET_OFFSET_HEIGHT')
  },
  methods: {
    async checkUserSubscribeNotice() {
      this.showSubscribeNotice = this.user ? !!this.user.subscribe_notice : false
      if (this.showSubscribeNotice) {
        await noticeMySubscribe()
      }
    },
    onClosePopup() {
      this.$store.dispatch('AddPopupViewList', this.popupSetting.image)
      this.$store.commit('SET_SHOW_POPUP', false)
    },
    onClickImage() {
      this.onClosePopup()
      location.href = this.popupObj.url
    },
    async handleCloseNotice() {
      this.showSubscribeNotice = false
      await this.$store.dispatch('GetUserInfo')
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue